import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  button: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 7px;
    padding: 0;
  `,
  group: ({ theme }) => css`
    display: flex;
    width: fit-content;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 4px;
    border: 1px solid ${theme.colors.neutral.variant[20]};
    border-radius: 8px;
  `,
  moreDropdownOpened: ({ theme }) => css`
    background-color: ${theme.colors.neutral.variant[10]};
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
